import { createContext, useState } from 'react';

import { User } from '@shared/types';

type ContextProps = {
    user: User | null;
    setUser: (user: User | null) => void;
    isUserDidFetch: boolean;
    setUserDidFetch: (fetch: boolean) => void;
};

export const AuthContext = createContext<Partial<ContextProps>>({});

export const AuthProvider = ({ children }: any) => {
    const [user, setUser] = useState<User | null>(null);
    const [isUserDidFetch, setUserDidFetch] = useState<boolean>(false);
    return (
        <AuthContext.Provider
            value={{
                user,
                setUser,
                isUserDidFetch,
                setUserDidFetch,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
